export enum LearnGroup {
  ecf_investor = 'Y_cOGxAAACQAR2HN',
  ecf_issuer = 'Y_cOkxAAACUAR2Pt',
  pstx_investor = 'Y_cO0xAAACQAR2UU',
  pstx_issuer = 'Y_cPBhAAACUAR2YL',
  ieo_investor = 'Y_cPWxAAAJp-R2eK',
  ieo_issuer = 'Y_cPgBAAACYAR2gz',
}
